import { defineComponent as c, createElementBlock as t, openBlock as a, mergeProps as f, unref as o, createElementVNode as m, createCommentVNode as i, normalizeClass as n, toDisplayString as l, renderSlot as p, createVNode as C } from "vue";
import r from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer.js";
import k from "../CloseButton.vue2.js";
import { useOUIAProps as D } from "../../helpers/ouia.js";
const w = { key: 0 }, S = /* @__PURE__ */ c({
  name: "PfNotificationDrawerHeader",
  __name: "NotificationDrawerHeader",
  props: {
    count: {},
    customText: {},
    onClose: {},
    title: { default: "Notifications" },
    unreadText: { default: "unread" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(u) {
    const s = u, d = D({ id: s.ouiaId, safe: s.ouiaSafe });
    return (e, y) => (a(), t("div", f(o(d), {
      class: o(r).notificationDrawerHeader
    }), [
      m("h1", {
        class: n(o(r).notificationDrawerHeaderTitle)
      }, l(e.title), 3),
      e.customText || e.count !== void 0 ? (a(), t("span", {
        key: 0,
        class: n(o(r).notificationDrawerHeaderStatus),
        "aria-live": "polite"
      }, l(e.customText || `${e.count} ${e.unreadText}`), 3)) : i("", !0),
      e.$slots.default || e.onClose ? (a(), t("div", {
        key: 1,
        class: n(o(r).notificationDrawerHeaderAction)
      }, [
        p(e.$slots, "default"),
        e.onClose ? (a(), t("div", w, [
          C(k, { onClick: e.onClose }, null, 8, ["onClick"])
        ])) : i("", !0)
      ], 2)) : i("", !0)
    ], 16));
  }
});
export {
  S as default
};
